module.exports = __webpack_public_path__ + "img/carteira.bd33e7e6.svg";